import {
  FetchGlobalCompanyTabsCacheKey,
  FetchGlobalCompanyTabsFilters,
  FetchGlobalCompanyTabsGqlQuery,
  FetchGlobalCompanyTabsLimit,
  FetchGlobalCompanyTabsPage,
  FetchGlobalCompanyTabsSort
} from '../../globalCompanyTabsTypes';

import { IndexQueryDefaultOptionsOpts } from '../../../common/reactQuery/hooks/useIndexQuery';
import { useEdIndexQuery } from '../../../common/reactQuery/hooks/useEdIndexQuery';

import {
  INITIAL_GLOBAL_COMPANY_TABS_FILTERS,
  INITIAL_GLOBAL_COMPANY_TABS_LIMIT,
  INITIAL_GLOBAL_COMPANY_TABS_PAGE,
  INITIAL_GLOBAL_COMPANY_TABS_SORT
} from '../../globalCompanyTabsConstants';

interface GlobalCompanyTabsOptions<NodeType> {
  cacheKey: FetchGlobalCompanyTabsCacheKey;
  initialFilters?: FetchGlobalCompanyTabsFilters;
  initialSort?: FetchGlobalCompanyTabsSort;
  initialPage?: FetchGlobalCompanyTabsPage;
  initialLimit?: FetchGlobalCompanyTabsLimit;
  options?: IndexQueryDefaultOptionsOpts<NodeType>;
  query: FetchGlobalCompanyTabsGqlQuery;
}

const scope = 'globalCompanyTabs';

function useGlobalCompanyTabs<NodeType>({
  cacheKey,
  initialFilters = INITIAL_GLOBAL_COMPANY_TABS_FILTERS,
  initialSort = INITIAL_GLOBAL_COMPANY_TABS_SORT,
  initialPage = INITIAL_GLOBAL_COMPANY_TABS_PAGE,
  initialLimit = INITIAL_GLOBAL_COMPANY_TABS_LIMIT,
  options = {},
  query
}: GlobalCompanyTabsOptions<NodeType>) {
  const {
    data,
    items,
    itemsError,
    itemsErrorMessage,
    itemsTotalCount,
    isFetched,
    isLoading,
    isPlaceholderData,
    currentPage,
    currentLimit,
    currentFilters,
    currentSort,
    updateItemCache,
    updateItemsCache,
    filterItems,
    changeItemsFilters,
    clearItemsFilters,
    sortItems,
    paginateItems,
    limitItems,
    prefetchItems
  } = useEdIndexQuery<NodeType>({
    cacheKey,
    scope,
    initialFilters,
    initialLimit,
    initialPage,
    initialSort,
    options,
    query
  });

  return {
    globalCompanyTabsData: data,
    globalCompanyTabs: items,
    globalCompanyTabsError: itemsError,
    globalCompanyTabsErrorMessage: itemsErrorMessage,
    globalCompanyTabsTotalCount: itemsTotalCount,
    globalCompanyTabsFetched: isFetched,
    globalCompanyTabsLoading: isLoading,
    globalCompanyTabsIsPlaceholderData: isPlaceholderData,
    globalCompanyTabsFilters: currentFilters,
    globalCompanyTabsSort: currentSort,
    globalCompanyTabsPage: currentPage,
    globalCompanyTabsLimit: currentLimit,
    updateGlobalCompanyTabCache: updateItemCache,
    updateGlobalCompanyTabsCache: updateItemsCache,
    filterGlobalCompanyTabs: filterItems,
    changeGlobalCompanyTabsFilters: changeItemsFilters,
    clearGlobalCompanyTabsFilters: clearItemsFilters,
    sortGlobalCompanyTabs: sortItems,
    paginateGlobalCompanyTabs: paginateItems,
    limitGlobalCompanyTabs: limitItems,
    prefetchGlobalCompanyTabs: prefetchItems
  };
}

export default useGlobalCompanyTabs;
